<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col v-if="item" class="mb-1">
          <router-link :to="{ name: 'UserUpdate', params: { id: item['@id'] } }" class="btn btn-sm btn-default">{{ $t('buttons.edit') }}</router-link>
          <router-link v-if="prevRoute.name === 'UserDataShow'" :to="{ name: 'UserDataShow', params: { id: item.userData['@id'] } }" class="btn btn-sm btn-default float-right">{{ $t('buttons.backToShow') }}</router-link>
          <router-link v-else :to="{ name: 'UserList' }" class="btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row v-if="item">
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col cols="12" lg="4">
                  <h6>{{$t('views.user.show.accountData')}}:</h6>
                  <p>
                    <b>{{$t('views.user.show.username')}}:</b> {{ item.username }}<br>
                    <b>{{$t('views.user.show.email')}}:</b> {{ item.email }}
                  </p>
                </b-col>
                <b-col cols="12" lg="4">
                  <h6>{{$t('views.user.show.userData')}}:</h6>
                  <p>
                    <b>{{$t('views.user.show.userdata.name')}}:</b> {{ item.userData.name }}<br>
                    <b>{{$t('views.user.show.userdata.surname')}}:</b> {{ item.userData.surname }}
                  </p>
                </b-col>
                <b-col cols="12" lg="4">
                  <AvatarDisplay v-model="avatarChanged" :item="item.userData"></AvatarDisplay>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import AvatarDisplay from '../userdata/component/AvatarDisplay/AvatarDisplay'

export default {
  computed: {
    ...mapGetters({
      deleteError: 'clienttype/del/error',
      error: 'clienttype/show/error',
      isLoading: 'clienttype/show/isLoading',
      item: 'clienttype/show/retrieved'
    })
  },

  components: {
    AvatarDisplay,
    Loader
  },

  data () {
    return {
      prevRoute: '',
      avatarChanged: 0
    }
  },

  watch: {
    avatarChanged: function () {
      if (this.avatarChanged === 1) {
        this.avatarChanged = 0
        this.retrieve(decodeURIComponent(this.$route.params.id))
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'clienttype/del/del',
      reset: 'clienttype/show/reset',
      retrieve: 'clienttype/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'UserList' }))
      }
    }
  }
}
</script>
